import { GenericException } from "./genericexception";

export class PlayerException extends GenericException
{
    constructor(message: string)
    {
       super(message);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/utils/exceptions/playerException.ts